import React from 'react';

export const SheetImportOverlay = ({ children }) => (
    <div data-testid="sheet-import-overlay" className="fixed inset-0 z-[110] flex items-center justify-center bg-black/30 p-2 sm:p-4">
        {children}
    </div>
);

export const SheetImportUrlTabs = ({
    url,
    onUrlChange,
    tabs,
    tab,
    onTabChange,
    onLoadTabs,
    loadingTabs,
    canLoad = true,
    loadError,
    onPreview,
    loadingPreview,
    canPreview,
    onSaveLink,
    savingLink,
    canEdit,
}) => (
    <div className={`grid gap-3 sm:grid-cols-2 ${onSaveLink
        ? 'lg:grid-cols-[minmax(0,1fr)_auto_minmax(14rem,0.6fr)_auto_auto]'
        : 'lg:grid-cols-[minmax(0,1fr)_auto_minmax(14rem,0.6fr)_auto]'}`}>
        <label className="text-xs font-medium text-gray-600">
            Google Sheets URL
            <input
                value={url}
                onChange={(event) => onUrlChange(event.target.value)}
                className="mt-1 w-full rounded border border-gray-300 px-2 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="https://docs.google.com/spreadsheets/d/..."
            />
        </label>
        <button type="button" onClick={onLoadTabs} disabled={!canLoad || loadingTabs} className="self-end rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
            {loadingTabs ? 'Loading…' : 'Load tabs'}
        </button>
        <label className="text-xs font-medium text-gray-600">
            Sheet tab
            <select value={tab} onChange={(event) => onTabChange(event.target.value)} className="mt-1 w-full rounded border border-gray-300 px-2 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-blue-500">
                {tabs.map((item) => <option key={item.gid} value={item.title}>{item.title}</option>)}
            </select>
        </label>
        {onPreview && (
            <button type="button" onClick={onPreview} disabled={!canPreview || loadingPreview} className="self-end rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
                {loadingPreview ? 'Previewing…' : 'Preview'}
            </button>
        )}
        {onSaveLink && (
            <button type="button" onClick={onSaveLink} disabled={!canEdit || savingLink || !tab} className="self-end rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
                {savingLink ? 'Saving…' : 'Save Link'}
            </button>
        )}
        {loadError}
    </div>
);

export const SheetImportSuccessBanner = ({ tone = 'success', children, forwardedRef }) => (
    <section
        ref={forwardedRef}
        className={`mb-4 rounded border p-3 text-sm ${tone === 'error'
            ? 'border-red-300 bg-red-50 text-red-900'
            : 'border-green-300 bg-green-50 text-green-900'}`}
    >
        {children}
    </section>
);

export const SheetImportFooter = ({
    applied,
    successLabel,
    onClose,
    canEdit,
    canApply,
    applying,
    onApply,
    applyLabel = 'Apply import',
    closeLabel = 'Close',
    closeAriaLabel,
    successTone = 'success',
    note,
}) => (
    <div className="flex shrink-0 items-center justify-between gap-2 border-t p-4">
        {applied ? (
            <>
                <span className={`text-sm font-medium ${successTone === 'error' ? 'text-red-700' : 'text-green-700'}`}>{successLabel}</span>
                <button type="button" onClick={onClose} className="rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-500">Done</button>
            </>
        ) : (
            <>
                {note ? <span className="text-xs text-blue-900">{note}</span> : <span />}
                <div className="flex justify-end gap-2">
                    <button type="button" aria-label={closeAriaLabel} onClick={onClose} className="rounded border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">{closeLabel}</button>
                    {canEdit && onApply && (
                        <button type="button" onClick={onApply} disabled={!canApply || applying} className="rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
                            {applying ? 'Applying…' : applyLabel}
                        </button>
                    )}
                </div>
            </>
        )}
    </div>
);

export const SheetImportHistory = ({ items, renderItem, emptyText = 'No import history yet.' }) => (
    <section className="mt-5 border-t pt-4">
        <h3 className="mb-2 text-sm font-semibold">Import history</h3>
        <div className="max-h-32 overflow-auto text-xs">
            {items?.length ? items.map(renderItem) : <p className="text-gray-500">{emptyText}</p>}
        </div>
    </section>
);
